<template>
    <div class="parents">
        <!-- <div class="steps">
            <div class="steps_top">
                <img class="steps_bar_size" :src="imagePath+'/info_entry.png'"/>
            </div>
        </div> -->
        
        <div class="prompt_issue">
            <div class="prompt_title_issue">
                <span class="prompt_title_sub_issue">请选择ETC发行机构</span>
            </div>
            <!-- <div class="prompt_but_all">
                <span class="prompt_but_all_title">查看全部</span>
            </div> -->
        </div>

        <div class="issue_card">
            <div class="issue_card_item" 
                :class="{select_cart: selected == index}" 
                v-for="(item,index) in listData" :key="item.id"
                @click="select(index)"
            >
                <div class="cart_left">
                    <img class="cart_img" :src="item.sysIcon" />
                </div>
                <div class="cart_mes_right">
                    <div class="cart_mes_title">
                        <img class="cart_title_img" :src="item.sysLogoPng" alt="">
                    </div>
                    <div class="cart_mes_container">
                        <span class="bank">{{item.sysRemark}}</span>
                        <span class="bank_msg">{{item.sysPreferential}}</span>
                    </div>
                </div>
                <!-- <input class="input_select"  
                    type="radio" 
                    name="radios" 
                    :value="index"
                    @click="select(index)"
                    v-model="selected" 
                    :checked="checked"
                /> -->
                <div class="select_state">
                    <i v-if="selected == index" class="cubeic-right"></i>
                    <i v-else class="cubeic-round-border"></i>
                </div>
                <!-- <div :class="selected == index ? 'input_select': 'input_not_select'">
                    <div class="below">
                        <div class="above"></div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="explain">
            <div class="rests">
                <div class="icon"><span>！</span></div>
                <span class="other">其他发行机构等待上线中...</span>
            </div>
            <cube-button class="confirm" :inline="true" @click="confirm()">确定所选发行机构</cube-button>
        </div>
        </div>
</template>

<script>
import { axios } from '../../util/request'
import { log } from 'util'
export default {

    data(){
        return{
            openId:this.$route.query.openId,
            type:this.$route.query.type,
            vehicleId:this.$route.query.vehicleId,
            plateColor: this.$route.query.plateColor,
            isValid: this.$route.query.isValid,
            imagePath: process.env.BASES_IMG_PATH,
            menImage:"",
            emblemImage:"",
            // 选框状态
            checked: true,
            selected: 0,
            listData: [],
        }
    },
    components: {
    },
    methods:{
        select(index) {
            this.selected = index;
        },
        confirm() {
            if (this.checked) {
                // console.log('通过')
                // console.log(this.selected);
                sessionStorage.setItem('SELECT-INDEX',this.selected);
                // 产品编号
                sessionStorage.setItem('PRODUCT-ID',this.listData[this.selected].productId);
                //发行服务机构编码
                sessionStorage.setItem('ISSUE-ID',this.listData[this.selected].issuerId);
                // name
                sessionStorage.setItem('ISSUE-NAME',this.listData[this.selected].name);
            }
            this.$router.push({name:'creditBank'});
        },
        // 获取发行方数据
        getData() {
            axios.get('Account/Product').then(data => {
                console.log(data);
                this.listData = data.list;
            })
        },
        // 获取选择的下标
        // getIndex() {
        //     // sessionStorage.getItem('SELECT-INDEX') || '0';
        //     // console.log(sessionStorage.getItem('SELECT-INDEX'));
        //     if (sessionStorage.getItem('SELECT-INDEX')) {
        //         this.selected = sessionStorage.getItem('SELECT-INDEX');
        //     }
        // },
        // check(){
        //     // 跳到车牌发行验证页面
        //     // this.$router.push({name:'creditBank'})
        //     this.$router.push({
        //         name:'creditBank',
        //         query:{
        //             openId:this.openId,
        //             plateNum:this.plateNum,
        //             plateColor:this.plateColor,
        //             vehicleId:this.vehicleId,
        //             type:this.type,
        //             isValid: this.isValid
        //             // vehicleType:1
        //         }
        //     })
        // },
    },
    mounted() {
        // 判断有无用户信息
        if(!sessionStorage.getItem('USER-ID') && !sessionStorage.getItem('TOKEN-ID')) {
            this.$router.push({name: 'home'});
        } else {
            this.getData();
            // this.getIndex();
        }
        
    }
}
</script>


<style lang="stylus" scoped>
.parents{
    width: calc(100%);
    height: calc(100%);
    margin: 0px;
    padding-bottom: 9.2rem;
    background-color: #ffffff;
    padding-top: 2px;
}
.steps{
    width: calc(100%);
    height: 6rem;
    margin: 0rem auto;
}
.steps_top{
    width: calc(100%);
    height: 4rem;
    padding: 1rem 0 1rem 0;
}
.steps_bar_size {
    width: calc(100%);
    height: calc(100%);
    background: #FEFFFF;
}

.prompt_issue{
    width: calc(100%);
    height: 3rem;
    margin: 0rem auto;
    background-color: #f18934 ;
}
.prompt_title_issue{
    width: calc(100%);
    height: 1rem;
    float:left;
}
.prompt_title_sub_issue{
    width: calc(100%);
    height: 1rem;
    color: #fff;
    font-weight: 500;
    line-height: 1rem;
    display: block;
    margin: 0rem 0 1rem 0;
    padding: 1rem 0 1rem 0;
    text-align: left ;
    text-indent: 1rem;
    font-size: 15px;
}

.prompt_but_all{
    width: 5.3rem;
    height: 1.2rem;
    border: 1px solid #EFEFEF;
    border-radius : 6px;
    background: #fff;
    float: right ;
    margin-right: 1rem;
}
.prompt_but_all_title{
    line-height: 1rem;
    text-align: center;
    color:#5F5F5F;
    font-size: 12px;
    font-weight: 600;
}
.issue_card {
    // height: calc(100%);
    width: calc(100%);
    padding-bottom: 1rem;
}
.issue_card_item {
    position:relative;
    height: 8.3rem;
    box-sizing:border-box;
    margin: 1rem 0.5rem 0;
    border-radius: 5px;
    background: #efefef;
    
}
.cart_left {
    height: 100%;
    width: 8.0rem;
    float: left;
}
.cart_img {
    display:block;
    width: 6.8rem;
    height: 4.34rem;
    float: left;
    margin-left: .6rem;
    margin-top: 2rem;
}
.cart_mes_title {
    height: 2.43rem;
    margin-top: .5rem;
}
.cart_mes_title .province {
    float: left;
    margin-top: .5rem;
}
.cart_title_img {
    display:block;
    height: 1.8rem;
    width: 9.0rem;
    margin-top: 0.5rem;
}
.cart_mes_right {
    float: left;
    height: 100%;
    width: 13.5rem;
    padding: 0 .1rem;
    font-size: 0.75rem;
}
.cart_mes_title span {
    margin-left: .5rem;
}
.cart_mes_container {
    height: 4.3rem;
    width: 100%;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: .1rem;
    line-height: 1.2rem;
    text-align:left;
}
.bank {
    font-size: .8rem;
    color: black;
}
.bank_msg {
    display: black;
    height: 5rem;
    font-size: .8rem;
    text-align: left;
    color: #5b5b5b;
}
.select_state {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
.cubeic-right::before {
    color: green;
}
// .input_select {
//     position: absolute;
//     top: 0.5rem;
//     right: 0.5rem;
// }
// .input_select {
//     height: 0.75rem;
//     width: 0.75rem;
//     border-radius: 0.375rem;
//     background: #56a23e;
//     position: absolute;
//     top: 0.5rem;
//     right: 0.5rem;
//     padding-top: 0.157rem;
//     padding-left: 0.13rem;
//     box-sizing: border-box;
//     overflow: hidden;
//     .below {
//         height: 0.3rem;
//         width: 0.5rem;
//         background: #ffffff;
//         transform: rotate(-45deg);
//         .above {
//             height: 0.2rem;
//             width: 0.4rem;
//             float: right;
//             background: #56a23e;
//         }
//     }
// }

// .input_not_select {
//     height: 0.75rem;
//     width: 0.75rem;
//     border-radius: 0.375rem;
//     background: #ccc;
//     position: absolute;
//     top: 0.5rem;
//     right: 0.5rem;
//     padding-top: 0.157rem;
//     padding-left: 0.12rem;
//     box-sizing: border-box;
    
//     overflow: hidden;
//     .below {
//         height: 0.3rem;
//         width: 0.5rem;
//         background: #ffffff;
//         transform: rotate(-45deg);
//         .above {
//             height: 0.2rem;
//             width: 0.4rem;
//             float: right;
//             background: #ccc;
//             overflow: hidden;
//         }
//     }
// }

.select_cart {
    border: 1px solid #4eabf8;
}
.explain {
    // margin-top: 1rem;
    position:fixed;
    height: 9.2rem;
    width: 100%;
    padding: 0 0.5rem;
    box-sizing: border-box;
    left: 0rem;
    bottom: 0rem;
    margin-top: 1rem;
    font-size: .8rem;
    color: #bf6e4b;
    background: #fff;
}
.explain .rests {
    height: 2rem;
    width: 100%;
    background: #fdecdf;
    border-radius: 5px;
    line-height: 2rem;
    text-align: left; 
}
.rests .other {
    margin-left: .5rem;
}
.explain .rests .icon {
    display: inline-block;
    line-height: 1rem;
    float: left;
    color: #fff;
    height: 1rem;
    width: 1rem;
    border-radius: .5rem;
    background: #ca7844;
    margin-left: .5rem;
    font-size: .5rem;
    margin-top: .5rem;
} 
.explain .rests .icon span {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    text-align: center;
    margin-left: .15rem;
}
.explain .confirm {
    height: 40px;
    width: 233px;
    border-radius: 20px;
    text-align:center;
    font-size: 15px;
    margin-top: 1.4rem;
    background: #fff;
    border: 1px solid #e48a3e;
    color: #e48a3e;
}
</style>


